import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=72ed40b6&isPage"
import script from "./index.mpx?vue&type=script&lang=js&isPage"
export * from "./index.mpx?vue&type=script&lang=js&isPage"
import style0 from "./index.mpx?vue&type=style&index=0&id=72ed40b6&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_3b94aa24%22%7D&isPage"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports